export class TooltipUtil {

	public static getTooltipValues(rangePoint: any, medianPoint: any, pointIndex, initialValue: any, baseValue: any): any {

		const seriesName = medianPoint.series.name;
		const seriesColor = medianPoint.series.color;

		const medianPointData = medianPoint?.series?.yData?.[pointIndex];
		const medianPercentageChange = (medianPointData - initialValue) / baseValue;

		// Range data is [low, high]
		let lowPointData;
		let highPointData;
		let lowPercentageChange;
		let highPercentageChange;

		if (rangePoint) {
			lowPointData = rangePoint.series.yData[pointIndex]?.[0];
			highPointData = rangePoint.series.yData[pointIndex]?.[1];
			lowPercentageChange = (lowPointData - initialValue) / baseValue;
			highPercentageChange = (highPointData - initialValue) / baseValue;
		}

		return new Map<string, any>([
			['seriesColor', seriesColor],
			['seriesName', seriesName],
			['low', { lowPointData, lowPercentageChange }],
			['median', { medianPointData, medianPercentageChange }],
			['high', { highPointData, highPercentageChange }]
		]);
	}

	public static getSortedPoints(points: any[]): Map<string, any> {
		const sortedPoints = new Map<string, object>();

		const reversedPoints = [...points].reverse();
		reversedPoints.forEach(point => {
			if (!sortedPoints.has(point.series.name)) {
				sortedPoints.set(point.series.name, {});
			}
			if (point.series.type === 'areasplinerange') {
				sortedPoints.get(point.series.name)['range'] = point;
			} else {
				sortedPoints.get(point.series.name)['median'] = point;
			}
		});

		return sortedPoints;
	}

}
